// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.router-view[data-v-7fea7b48] {\n  min-height: 300px;\n}\n\n", ""]);
// Exports
module.exports = exports;
